module.exports = __webpack_public_path__ + "static/media/assembly_C2.05dd4190.png";